import React from "react";
import styles from "./FullProfile.module.css";

export default function ProfileSummary({ data }) {
  return (
    <div className={styles.profileData}>
      <h3>
        About the <span>Institution</span>
      </h3>
      <div>
        {data &&
          data.about &&
          data.about.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}
